import imgOne from '../../assets/blogs/1.png';
import imgTwo from '../../assets/blogs/2.png';
import imgThree from '../../assets/blogs/3.png';

const BlogData = [
    {
        'img': imgOne,
        'url': 'new-technology-make-for-dental-operation',
        'title':'Modern Technology in Dental Treatment at Veloura',
        'description':'Discover how Veloura Dental and Homoeopathy uses the latest dental technology to provide pain-free, efficient treatments in Ahmedabad.',
        'category': 'TECHNOLOGY'
    },
     {
        'img': imgTwo,
        'url':'regular-dental-care-make-your-smile-brighter',
        'title':'Regular Dental Care Makes Your Smile Brighter',
        'description':'Learn why regular dental check-ups are essential for maintaining oral health and how our expert team at Nikol can help.',
        'category': 'DENTAL'
    },
    {
        'img': imgThree,
        'url':'dental-hygiene-for-all-age-to-make-smile',
        'title':'Dental Hygiene Tips for All Ages',
        'description':'Veloura Dental and Homoeopathy shares essential dental hygiene practices to keep your family\'s smiles healthy at every age.',
        'category': 'HYGIENE'
    }
];

export default BlogData;